

var _autobillingTerms = _interopRequireDefault(require("./autobillingTerms"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
module.exports = {
  getItemOptions: _autobillingTerms["default"].getItemOptions,
  getItemName: _autobillingTerms["default"].getItemName,
  getTermsText: _autobillingTerms["default"].getTermsText
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/autobilling-terms/index.js
// module id = ../node_modules/xo-page-components/src/autobilling-terms/index.js
// module chunks = 0